'use strict';

require('../../styles/theme.scss');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../core/a11y');

require('../core/flickity-ios');

var _stickyHeader = require('../components/stickyHeader');

var _nav = require('../components/nav');

var _mobileNav = require('../components/mobileNav');

var _search = require('../components/search');

var _overlay = require('../components/overlay');

var _scrollTo = require('../components/scrollTo');

var _addToCart = require('../components/addToCart');

var _cartPopup = require('../components/cartPopup');

var _sliders = require('../components/sliders');

var _promoBar = require('../components/promoBar');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import CSS
window.jQuery = _jquery2.default;

// Import jQuery

window.$ = _jquery2.default;

// Vendor


// Core


// Components


document.addEventListener('DOMContentLoaded', function () {
  (0, _stickyHeader.init)();
  (0, _mobileNav.init)();
  (0, _nav.init)();
  (0, _search.init)();
  (0, _overlay.init)();
  (0, _scrollTo.init)();
  (0, _addToCart.init)();
  (0, _cartPopup.init)();
  (0, _sliders.init)();
  (0, _promoBar.init)();
});

//Reinit when theme section settings have been updated
(0, _jquery2.default)(document).on('shopify:section:load', function () {
  (0, _sliders.init)();
});